// extracted by mini-css-extract-plugin
export default {"input":"ZYUJX","container":"a38uD"};